export default "__VITE_ASSET__v4OOgA9N__"